export const env = "dev";
export const base_path = "";
export const image_path =''
export const base_api_url="https://api-dev.qrnyama.com/";
export const base_ui_url="https://app-dev.qrnyama.com/";
export const google_client_id = "44230808085-38s9mvos4imkipjmh2jt83rpqsoe25st.apps.googleusercontent.com";
export const DEFAULT_STRIPE_PUBLIC_KEY = 'pk_test_51SeieaHzgzAgXup3Y6DVeJqIzaQjzPlyXZWnOCOkSW8PXJ49gYwG8T10x25v8IethhquW97WjhqPNviMlHicAmDh00feT92hJr';
export const SKIP_SUBSCRIPTION_CHECK = true;